const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    neutral: {
        '00': '#FFFFFF',
        10: '#FDFCFE',
        20: '#F5F2F8',
        30: '#EBE7EE',
        40: '#E1DDE4',
        50: '#D1CFD3',
        60: '#C2C0C4',
        70: '#B4B1B6',
        80: '#A9A6AA',
        90: '#9A979C',
        100: '#8C898E',
        110: '#7D7B80',
        120: '#6F6D71',
        130: '#615E63',
        140: '#555257',
        150: '#464549',
        160: '#3A393D',
        170: '#29282D',
        180: '#1B191F',
        190: '#0F0D13',
        200: '#000000'
    },
    purple: {
        50: '#F6EBFF',
        60: '#E2C1FF',
        70: '#D4A3FF',
        80: '#C17AFF',
        90: '#B560FF',
        100: '#A238FF',
        110: '#9333E8',
        120: '#7328B5',
        130: '#591F8C',
        140: '#44186B',
        150: '#32124E'
    },
    teal: {
        50: '#F5FEFE',
        60: '#DEFDFB',
        70: '#CFFCF9',
        80: '#B9FBF7',
        90: '#ABFAF5',
        100: '#96F9F3',
        110: '#89E3DD',
        120: '#6BB1AD',
        130: '#538986',
        140: '#3F6966',
        150: '#2E4D4A'
    },
    orange: {
        50: '#FFF0EC',
        60: '#FFD0C3',
        70: '#FFB9A6',
        80: '#FF997D',
        90: '#FF8564',
        100: '#FF673D',
        110: '#E85E38',
        120: '#B5492B',
        130: '#8C3922',
        140: '#6B2B1A',
        150: '#461C11'
    },
    acid: {
        50: '#FFFFEF',
        60: '#FEFFCE',
        70: '#FEFFB6',
        80: '#FDFF94',
        90: '#FDFF80',
        100: '#FCFF60',
        110: '#E5E857',
        120: '#B3B544',
        130: '#8B8C35',
        140: '#6A6B28',
        150: '#4A4A1C'
    },
    green: {
        50: '#E8F5F9',
        60: '#C8E6C9',
        70: '#A5D6A7',
        80: '#4DC977',
        90: '#66BB6A',
        100: '#00B23D',
        110: '#43A047',
        120: '#388E3C',
        130: '#2E7D32',
        140: '#1B5E20',
        150: '#1B5E20'
    },
    carrot: {
        50: '#FFFAEF',
        60: '#FEF2D6',
        70: '#FEE2AE',
        80: '#FECE85',
        90: '#FEBA67',
        100: '#FE9935',
        110: '#DA7726',
        120: '#B6581A',
        130: '#933E10',
        140: '#792B0A',
        150: '#792B0A'
    },
    red: {
        50: '#FFEBEE',
        60: '#FFCDD2',
        70: '#EF9A9A',
        80: '#E57373',
        90: '#EF5350',
        100: '#F44336',
        110: '#E53935',
        120: '#D32F2F',
        130: '#C62828',
        140: '#B71C1C',
        150: '#B71C1C'
    },
    brand: {
        flame: '#FFCE52',
        lava: '#EF3841',
        pink: '#E64796',
        magenta: '#D449D4',
        indigo: '#6849FF',
        blue: '#4773EB',
        jellyfish: '#30E0C6',
        algae: '#74E788'
    },
    // FIXME: replace with proper token when design is ready
    cover: {
        border: {
            light: '#6F6D7114',
            dark: '#A9A6AA1F'
        }
    }
};
export default colors;

//# sourceMappingURL=colors.js.map